import { translate } from 'i18n/i18n'
import { maintenanceStore } from 'stores/maintenanceStore/maintenanceStore'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { apiFetch } from './apiFetch'

export const reportApiFailure = (
  failedEndpoint: '/hub-maintenance' | '/user-app-startup' | '/has-agreed-to-current-acceptance-package',
  errorType: 'api_unreachable' | 'maintenance_active',
) => {
  // Show the maintenance banner
  maintenanceStore.setState(() => ({
    maintenanceMessage: translate.phrases.banyanApp(
      'Our system is undergoing maintenance. Some features may be temporarily unavailable.',
    ),
  }))

  // Report to backend (fire-and-forget)
  const userId = userDetailsStore.getState()?.id ?? null

  apiFetch({
    url: '/log-maintenance-event',
    body: { failedEndpoint, errorType, userId: userId ? Number(userId) : null },
  }).catch(() => {
    // If the reporting endpoint also fails, there's nothing more we can do
  })
}
